import { render } from "./contact-page.vue?vue&type=template&id=faa0049c&ts=true"
import script from "./contact-page.vue?vue&type=script&lang=ts"
export * from "./contact-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__